﻿import { Inject, Pipe, Injectable } from "@fiqas/angular-utils"
import { FIQAssist  } from "../app";

export class IsoDateFilter {
        @Pipe({
            module: FIQAssist,
            selector: 'isotodate',
            pure:true
        })
        public static IsoToDate() {
            return (dateString: string):Date => {
                if(dateString === undefined)
                    return null;
                return Date.parseOrNull(dateString);
            };
        }
    }